"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
// 车型弹窗组件
var react_1 = __importStar(require("react"));
var request_1 = require("../../utils/request");
var dataStorage_1 = require("../../utils/dataStorage");
var SidePullPop_1 = require("../SidePullPop");
var WithErrorHandler_1 = require("../WithErrorHandler");
var ProductList = function (props) {
    var _a = __read(react_1.useState({}), 2), listData = _a[0], setListData = _a[1];
    var productsPop_list = react_1.useRef(null);
    var cache_lineId = react_1.useRef();
    var cache_defaultProductId = react_1.useRef();
    react_1.useEffect(function () {
        if ((props.show || typeof props.getDataCallbackFun != 'undefined') && props.lineId && (props.lineId != cache_lineId.current || props.productId != cache_defaultProductId.current)) {
            if (productsPop_list && productsPop_list.current) {
                productsPop_list.current.scrollTop = 0;
            }
            cache_lineId.current = props.lineId;
            setListData({});
            getProData(props.lineId);
        }
    }, [props]);
    var getProData = react_1.useCallback(function (lineId) {
        // 获取车型数据
        var ajaxUrl = props.ajaxUrl, saveKey = props.saveKey;
        dataStorage_1.getStorageData(saveKey + lineId).then(function (data) {
            // 本地有车型数据
            // @ts-ignore
            setListData(data);
            props.getDataCallbackFun && props.getDataCallbackFun(data);
        }, function (error) {
            // 本地没有车型数据 异步获取数据
            ajaxUrl &&
                request_1.request(ajaxUrl, {
                    lineId: lineId
                }, "jsonp")
                    .then(function (response) {
                    if (response.code == 0) {
                        var data = response.entity.data;
                        dataStorage_1.setStorageData({
                            key: saveKey + lineId,
                            value: data,
                            expire: 10
                        });
                        setListData(data);
                        props.getDataCallbackFun && props.getDataCallbackFun(data);
                    }
                    else {
                        console.log(response.message);
                    }
                })
                    .catch(function (error) {
                    console.log(error);
                });
        });
    }, [props]);
    var selectProduct = react_1.useCallback(function (obj) {
        var callbackFun = props.callbackFun;
        var newObj = __assign({}, obj);
        if (props.showSelectAll && !obj.productId) {
            newObj = __assign(__assign({}, newObj), { lineId: props.lineId });
        }
        cache_defaultProductId.current = obj.productId;
        callbackFun && callbackFun(newObj);
    }, [props.callbackFun]);
    /** 点击底部查看其他品牌的按钮的事件 */
    var onGoOtherBrandPage = react_1.useCallback(function () {
        if (typeof props.onClickSelecPageFn !== 'undefined') {
            props.onClickSelecPageFn();
        }
        if (typeof window !== 'undefined') {
            window.location.href = "//m.58che.com/car/brand.html";
        }
    }, [props]);
    var disableMargin = {
        marginBottom: 0,
    };
    return (react_1.default.createElement(SidePullPop_1.SidePullPop, { closeFun: props.closeFun, show: props.show, popId: "productsPop", scrollId: "productsPop_list", title: "\u9009\u62E9\u8F66\u578B" },
        react_1.default.createElement("dl", { className: "newcar_ui_popList", 
            // @ts-ignore
            ref: productsPop_list, id: "productsPop_list", style: props.showGoSelectPage ? __assign({}, disableMargin) : {} },
            Object.keys(listData).length == 0 && (react_1.default.createElement("p", { className: "newcar_ui_empty" }, "\u6682\u65E0\u6570\u636E")),
            Object.keys(listData).map(function (key) {
                return Array.isArray(listData[key]) && listData[key].length > 0 ? (react_1.default.createElement(react_1.Fragment, { key: key },
                    props.showSelectAll && (react_1.default.createElement("dd", null,
                        react_1.default.createElement("a", { className: "newcar_ui_name", style: { borderTop: "1px solid #e6e6e6" }, onClick: function () { return selectProduct({}); } }, "\u9009\u62E9\u5168\u90E8"))),
                    react_1.default.createElement("dt", { className: "newcar_ui_subTitle" }, key),
                    listData[key].map(function (i) { return (react_1.default.createElement("dd", { key: i.productId },
                        react_1.default.createElement("a", { className: "newcar_ui_name " + (i.productId == props.productId ? "cur" : ""), onClick: function () { return selectProduct(i); } },
                            " ",
                            i.showName))); }))) : (react_1.default.createElement("div", { style: {
                        padding: "50px 0",
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#ccc"
                    }, key: key }, "\u6682\u65E0\u8F66\u578B"));
            })),
        props.showGoSelectPage && react_1.default.createElement("div", { className: "newcar_ui-select-page" },
            react_1.default.createElement("div", { onClick: onGoOtherBrandPage, className: "newcar_ui-select-page-inner" }, "\u67E5\u770B\u5176\u4ED6\u54C1\u724C/\u8F66\u7CFB"))));
};
var envStr = "";
if (typeof window !== "undefined") {
    envStr = window.location.host.indexOf("-tests") != -1 ? "-tests" : "";
}
ProductList.defaultProps = {
    saveKey: "productList",
    ajaxUrl: "//m" + envStr + ".58che.com/home.php?c=ajax_User&a=GetProInfo",
    show: false,
    // eslint-disable-next-line no-empty-function
    closeFun: function () { },
    // eslint-disable-next-line no-empty-function
    callbackFun: function (obj) { },
    showGoSelectPage: false
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(ProductList));
